export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0,
            showTour: false,
            tourData: [
                {
                    target: '#welcome-btn',
                    title: '欢迎使用！',
                    content: '欢迎来到我们的应用，让我们开始引导之旅吧！',
                    position: 'bottom',
                    nextText: '开始探索',
                },
                {
                    target: '#feature-btn',
                    title: '功能介绍',
                    content: '这里是主要功能区域，您可以在这里进行各种操作。',
                    position: 'bottom',
                    nextText: '前进',
                    prevText: '回到开始',
                },
                {
                    target: '#finish-btn',
                    title: '设置完成',
                    content: '恭喜！您已经完成了所有设置，现在可以开始使用了。',
                    position: 'top',
                    prevText: '返回上一步',
                }
            ]
        };
    }

    @bind
    startTour() {
        this.set({
            showTour: true,
            currentStep: 0
        });
    }

    @bind
    close() {
        this.set({
            showTour: false
        });
    }
}